<div
    #resizerHandle
    class="flex h-full items-center justify-center border-border-300 transition-colors hover:cursor-col-resize hover:bg-surface-300 focus-visible:focus-visible-base"
    role="separator"
    tabindex="0"
    [attr.aria-label]="'SHARED.BUTTON.RESIZE' | translate"
    [attr.aria-orientation]="'vertical'"
    [attr.aria-valuemax]="maxWidth()"
    [attr.aria-valuemin]="minWidth()"
    [attr.aria-valuenow]="currentWidth()"
    (keydown)="onKeyDown($event)"
>
    <interacta-icon
        aria-hidden="true"
        class="size-16 rotate-90 text-text-mid-contrast"
        [icon]="'equals'"
    />
</div>
